import {
  BudgetActivityAttributes,
  listBudgetActivitiesQuery,
  ModifyInvoiceActivityMapping,
} from '@shared/services/gql.service';
import { InvoiceModel } from '@shared/store/invoice/invoice.model';

import { MapActivitiesTabGridRow } from '../map-activities-tab.model';

export enum MapActivityType {
  ACTIVITY_DISCOUNT = 'Discount',
  ACTIVITY_INVESTIGATOR = 'Investigator',
  ACTIVITY_PASSTHROUGH = 'Passthrough',
  ACTIVITY_SERVICE = 'Services',
}

export type ActivityCategories = {
  index: number;
  level: string;
  name: string;
};

export interface MapActivitiesGridRow extends MapActivitiesTabGridRow {
  isNewLineItemRow?: boolean;
  isNewRow: boolean;
}

export interface MapActivitiesModalParams {
  attributes: BudgetActivityAttributes[];
  budgetActivityOptions: listBudgetActivitiesQuery[];
  invoice: InvoiceModel;
  items: MapActivitiesTabGridRow[];
  lastUpdated: string;
  mappingLineItemsType?: 'integration' | 'pdf' | null;
  noteId: string;
  noteMessage: string;
}

export interface MapActivitiesModalReturnData {
  isNotesChanged?: boolean;
  itemsToSave?: ModifyInvoiceActivityMapping[];
  notesMessage?: string;
}

export interface MapActivitiesTotals {
  ACTIVITY_DISCOUNT: number;
  ACTIVITY_INVESTIGATOR: number;
  ACTIVITY_PASSTHROUGH: number;
  ACTIVITY_SERVICE: number;
  invoice_total: number;
}
